import { dew as _discriminantDew } from "./discriminant";
import { dew as _unionDew } from "./union";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.union = exports.discriminant = void 0;
  var discriminant_1 = _discriminantDew();
  Object.defineProperty(exports, "discriminant", {
    enumerable: true,
    get: function () {
      return discriminant_1.discriminant;
    }
  });
  var union_1 = _unionDew();
  Object.defineProperty(exports, "union", {
    enumerable: true,
    get: function () {
      return union_1.union;
    }
  });
  return exports;
}